import { render, staticRenderFns } from "./NavbarMainConfig.vue?vue&type=template&id=c4c6a902&scoped=true"
import script from "./NavbarMainConfig.vue?vue&type=script&lang=js"
export * from "./NavbarMainConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c6a902",
  null
  
)

export default component.exports